import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31d9d41e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-choose-person" }
const _hoisted_2 = { class: "uf-choose-person__body" }
const _hoisted_3 = { action: "/" }
const _hoisted_4 = { class: "uf-choose-person__info" }
const _hoisted_5 = { class: "uf-button" }
const _hoisted_6 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_Staff = _resolveComponent("Staff")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_Customer = _resolveComponent("Customer")!
  const _component_Factory = _resolveComponent("Factory")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_nav_bar, {
            title: "选择人员",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
          }),
          _createElementVNode("form", _hoisted_3, [
            _createVNode(_component_van_search, {
              modelValue: _ctx.search_value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search_value) = $event)),
              shape: "round",
              placeholder: "请输入搜索关键词",
              onSearch: _cache[2] || (_cache[2] = () => _ctx.onSearch(_ctx.search_value, false))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_tabs, {
              active: _ctx.active,
              "onUpdate:active": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.active) = $event)),
              color: "#3d6eeb",
              onChange: _ctx.changeTab
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tab, {
                  title: "员工",
                  name: "staff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Staff, {
                      ref: "search_employees",
                      multiple: _ctx.multiple,
                      modelValue: _ctx.state.staff,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.staff) = $event))
                    }, null, 8, ["multiple", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_tab, {
                  title: "客户",
                  name: "customer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Customer, {
                      ref: "search_customer",
                      multiple: _ctx.multiple,
                      modelValue: _ctx.state.customer,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.customer) = $event))
                    }, null, 8, ["multiple", "modelValue"])
                  ]),
                  _: 1
                }),
                false
                  ? (_openBlock(), _createBlock(_component_van_tab, {
                      key: 0,
                      title: "供应商",
                      name: "factory"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Factory, {
                          ref: "search_factory",
                          multiple: _ctx.multiple,
                          modelValue: _ctx.state.factory,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.factory) = $event))
                        }, null, 8, ["multiple", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["active", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    plain: "",
                    class: "btn",
                    square: "",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("已选 " + _toDisplayString(_ctx.state[_ctx.active].length), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_van_button, {
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.confirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}